module.exports = __webpack_public_path__ + "static/media/clipboard-check.aa80e415.svg";